import { render, staticRenderFns } from "./PFLoanAdvanceDeductionList.vue?vue&type=template&id=b9f1f7da"
import script from "./PFLoanAdvanceDeductionList.vue?vue&type=script&lang=js"
export * from "./PFLoanAdvanceDeductionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports